<template>
    <div>
        <busca-por-codigo v-if="documentoValidado === false" @validarDocumento="validarDocumento"/>
        <documento-validado v-if="documentoValidado === true"
                            :codigoDocumento="codigoDocumento"
                            :arquivoSrc="arquivoSrc"
                            :dataHoraValidacao="dataHoraValidacao"
                            @downloadDocumento="baixarDocumentos"
                            @voltar="voltar"
        />
    </div>
</template>

<script>
import BuscaPorCodigo from './BuscaPorCodigo'
import DocumentoValidado from './DocumentoValidado'
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'

export default{
    name: 'ValidarDocumento',
    components: {DocumentoValidado, BuscaPorCodigo},
    data(){
        return {
            documentoValidado: false,
            codigoDocumento: '',
            dataHoraValidacao: null,
            arquivoSrc: '',
            idVirtualizado: null,
            nomeDocumento: null,
            menuAnteriorRetraido: false
        }
    },
    async mounted() {
        this.menuAnteriorRetraido = this.$store.state.loki.asideClosed
        this.$store.state.loki.asideClosed = true
        await this.verificarSeUrlPossuiCodigo()
    },
    computed:{
        ...mapState(['loki']),
    },
    methods:{
        async baixarDocumentos(){
            await this.$store.dispatch(actionTypes.BAIXAR_DOCUMENTOS_VIRTUALIZADOS,
                {id: this.idVirtualizado, nome: this.nomeDocumento}
            )
        },
        voltar(){
            this.$router.push({ name: 'ValidarDocumento' })
        },
        async validarDocumento(codigo){
            const resposta = await this.$store.dispatch(
                actionTypes.VALIDAR_DOCUMENTO_VIRTUALIZADO, codigo
            )
            this.atribuirDadosResposta(resposta)
            await this.$router.push({name: 'ValidarDocumentoDireto', params: {codigo: codigo}})
        },
        atribuirDadosResposta(dados){
            this.dataHoraValidacao = dados.dataHoraValidacao
            this.documentoValidado = dados.valido
            this.arquivoSrc = dados.arquivoSrc
            this.idVirtualizado = dados.idVirtualizado
            this.nomeDocumento = dados.nome
        },
        async verificarSeUrlPossuiCodigo(){
            if(this.$route.params.codigo){
                this.pegarCodigoDocumentoDaRota()
                await this.validarDocumento(this.$route.params.codigo)
            }else{
                this.documentoValidado = false
            }
        },
        pegarCodigoDocumentoDaRota() {
            this.codigoDocumento = this.$route.params.codigo
        }
    },
    beforeDestroy(){
        this.$store.state.loki.asideClosed = this.menuAnteriorRetraido
    },
    beforeRouteLeave(to, from, next) {
        if(from.fullPath !== '/validar-documento')
            this.documentoValidado = false
        next()
    }
}
</script>
